<app-navbar-style-three></app-navbar-style-three>
<div class="bg-image">
    <div class="container" style="padding-top: 30px; padding-bottom: 30px">
        <div class="row">
            <div class="col-md-3">
                <div align="left" style="padding-left: 20px">
                    <p style="font-size: 26px">News & Events</p>
                </div>
                <div class="list-group list-group-flush">
                    <ng-container *ngFor="let item of items">
                        <button
                            [class.active]="selectedItem === item.Url"
                            (click)="selectItem(item.Url)"
                            class="newA linkStyle list-group-item list-group-item-action"
                        >
                            {{ item.Name }}
                        </button>
                    </ng-container>
                </div>
            </div>
            <div class="col-md-9">
                <div *ngIf="selectedItem && selectedItem == '2024'">
                    <div class="row" style="margin-top: 20px">
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button
                                        class="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        School
                                    </button>
                                </h2>
                                <div
                                    id="collapseOne"
                                    class="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_four_school_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this.twenty_four_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        High School
                                    </button>
                                </h2>
                                <div
                                    id="collapseTwo"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this
                                                    .twenty_four_high_school_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this
                                                        .twenty_four_high_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                    >
                                        College
                                    </button>
                                </h2>
                                <div
                                    id="collapseThree"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_four_college_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this
                                                        .twenty_four_college_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedItem && selectedItem == '2023'">
                    <div class="row" style="margin-top: 20px">
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button
                                        class="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        School
                                    </button>
                                </h2>
                                <div
                                    id="collapseOne"
                                    class="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_three_school_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this
                                                        .twenty_three_college_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        High School
                                    </button>
                                </h2>
                                <div
                                    id="collapseTwo"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this
                                                    .twenty_three_high_school_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this
                                                        .twenty_three_high_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                    >
                                        College
                                    </button>
                                </h2>
                                <div
                                    id="collapseThree"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this
                                                    .twenty_three_college_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this
                                                        .twenty_three_college_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedItem && selectedItem == '2022'">
                    <div class="row" style="margin-top: 20px">
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button
                                        class="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        School
                                    </button>
                                </h2>
                                <div
                                    id="collapseOne"
                                    class="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_two_school_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this.twenty_two_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        High School
                                    </button>
                                </h2>
                                <div
                                    id="collapseTwo"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this
                                                    .twenty_two_high_school_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this
                                                        .twenty_two_high_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                    >
                                        College
                                    </button>
                                </h2>
                                <div
                                    id="collapseThree"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_two_college_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this.twenty_two_college_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedItem && selectedItem == '2021'">
                    <div class="row" style="margin-top: 20px">
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button
                                        class="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        School
                                    </button>
                                </h2>
                                <div
                                    id="collapseOne"
                                    class="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_one_school_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this.twenty_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        High School
                                    </button>
                                </h2>
                                <div
                                    id="collapseTwo"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this
                                                    .twenty_one_high_school_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this
                                                        .twenty_one_high_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                    >
                                        College
                                    </button>
                                </h2>
                                <div
                                    id="collapseThree"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_one_college_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this.twenty_one_college_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedItem && selectedItem == '2020'">
                    <div class="row" style="margin-top: 20px">
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button
                                        class="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        School
                                    </button>
                                </h2>
                                <div
                                    id="collapseOne"
                                    class="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_school_data != null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this.twenty_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        High School
                                    </button>
                                </h2>
                                <div
                                    id="collapseTwo"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_high_school_data !=
                                                null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this.twenty_high_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                    >
                                        College
                                    </button>
                                </h2>
                                <div
                                    id="collapseThree"
                                    class="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div class="accordion-body">
                                        <ng-container
                                            *ngIf="
                                                this.twenty_college_data != null
                                            "
                                        >
                                            <p
                                                [innerHTML]="
                                                    this.twenty_high_school_data
                                                        .DetailsEn
                                                "
                                            ></p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
